import React, { useEffect, useRef, memo, createElement, Component } from 'react';
import { motion, useInView, useScroll, useTransform } from 'framer-motion';
export function LandingPage() {
  const heroRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: heroRef,
    offset: ['start start', 'end start']
  });
  const heroScale = useTransform(scrollYProgress, [0, 0.5], [1, 0.95]);
  // Smooth scroll function
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  // Track Lead event for Meta Pixel
  const trackLeadEvent = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'El Arte de Influir en las Personas',
        value: 7.97,
        currency: 'USD'
      });
    }
  };
  // Meta Pixel initialization
  useEffect(() => {
    // Initialize Meta Pixel
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Simplified: append to head instead of inserting before existing script
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    if (window.fbq) {
      window.fbq('init', '1028987868805144');
      window.fbq('track', 'PageView');
    }
    // Add noscript fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1028987868805144&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] text-[#F5F5DC] min-h-screen" data-id="element-2">
      {/* Hero Section */}
      <motion.section ref={heroRef} style={{
      scale: heroScale
    }} className="relative flex items-center justify-center px-6 py-10 md:py-12" data-id="element-3">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-5">
            <h1 className="text-5xl md:text-7xl font-bold mb-4 leading-tight text-[#D4AF37]" data-id="element-6">
              ¿Te sientes invisible?
            </h1>
            <p className="text-xl md:text-2xl mb-5 text-[#F5F5DC]/90 leading-relaxed" data-id="element-7">
              Entras a un lugar, ves mujeres que te gustan, te acercas y...{' '}
              <span className="text-[#8B2635] font-semibold" data-id="element-8">nada ocurre</span>.
            </p>
            <p className="text-lg md:text-xl mb-7 text-[#F5F5DC]/80" data-id="element-9">
              Tu cuerpo está limpio, tus músculos "en forma", tu camisa nueva...
              pero tu interior grita inseguridad.
            </p>
            <motion.button onClick={scrollToPricing} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-[#8B2635] text-[#F5F5DC] px-10 py-5 rounded-lg text-xl font-bold hover:bg-[#A02D3F] transition-colors shadow-2xl cursor-pointer" data-facebook-pixel="no-track" data-id="element-10">
              Descarga el eBook Ahora
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="flex justify-center" data-id="element-11">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2ysTmm9nA2h7G17RwfQWVo/ChatGPT_Image_26_nov_2025%2C_01_01_29_a.m..png" alt="El Arte de Influir en las Personas" className="max-w-md w-full shadow-2xl rounded-lg" data-id="element-12" />
          </motion.div>
        </div>
      </motion.section>

      {/* Problem Section */}
      <Section data-id="element-13">
        <div className="max-w-4xl mx-auto text-center" data-id="element-14">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-[#D4AF37]" data-id="element-15">
            Si alguna vez has sentido esa punzada de impotencia...
          </h2>
          <p className="text-xl md:text-2xl mb-3 leading-relaxed" data-id="element-16">
            Ese deseo de desaparecer cuando las miradas se desvían como si
            fueras invisible.
          </p>
          <p className="text-lg md:text-xl text-[#F5F5DC]/80 leading-relaxed" data-id="element-17">
            Este mensaje es para ti.
          </p>
        </div>
      </Section>

      {/* Solution Section */}
      <Section delay={0.2} data-id="element-18">
        <div className="max-w-5xl mx-auto" data-id="element-19">
          <div className="bg-[#8B2635]/10 border-2 border-[#8B2635] rounded-2xl p-8 md:p-12" data-id="element-20">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center text-[#D4AF37]" data-id="element-21">
              Lo que necesitas no es más gym, ni ropa cara, ni frases robadas
            </h2>
            <p className="text-xl md:text-2xl text-center mb-8 leading-relaxed" data-id="element-22">
              Necesitas algo mucho más profundo:{' '}
              <span className="text-[#D4AF37] font-semibold" data-id="element-23">
                volver a creer en ti
              </span>
              .
            </p>

            <div className="text-center mb-6" data-id="element-24">
              <h3 className="text-4xl md:text-5xl font-bold text-[#D4AF37] mb-3" data-id="element-25">
                EL ARTE DE INFLUIR EN LAS PERSONAS
              </h3>
              <p className="text-xl md:text-2xl text-[#F5F5DC]/90" data-id="element-26">
                Transformar esa inseguridad silenciosa en magnetismo auténtico
              </p>
            </div>
          </div>
        </div>
      </Section>

      {/* What You'll Learn */}
      <Section delay={0.3} data-id="element-27">
        <div className="max-w-6xl mx-auto" data-id="element-28">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center text-[#D4AF37]" data-id="element-29">
            Una guía de transformación personal
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-30">
            {['Superar el miedo al rechazo', 'Romper con el diálogo interno que sabotea tus relaciones', 'Desarrollar una presencia auténtica que atrae sin esfuerzo', 'Convertir la ansiedad social en calma natural', 'Entender el lenguaje corporal y las señales reales', 'Generar conexión genuina sin manipulación'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] border border-[#8B2635]/30 rounded-xl p-5 hover:border-[#8B2635] transition-colors" data-id="element-31">
                <div className="flex items-start gap-3" data-id="element-32">
                  <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" data-id="element-33"></div>
                  <p className="text-lg md:text-xl text-[#F5F5DC]" data-id="element-34">{item}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </Section>

      {/* Who Are You */}
      <Section delay={0.2} data-id="element-35">
        <div className="max-w-4xl mx-auto" data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center text-[#D4AF37]" data-id="element-37">
            ¿Quién eres tú?
          </h2>
          <div className="space-y-4 text-lg md:text-xl leading-relaxed" data-id="element-38">
            <p data-id="element-39">
              Eres un hombre entre 20 y 40 años que ya intentó "ligar" de mil
              formas. Has leído, visto videos, probado frases...{' '}
              <span className="text-[#8B2635] font-semibold" data-id="element-40">
                y nada funciona
              </span>
              .
            </p>
            <p data-id="element-41">
              Te sientes invisible. Y eso duele más que cualquier rechazo.
              Porque no solo es frustración — es una herida al ego, al valor
              personal, al sentido de pertenencia.
            </p>
            <p className="text-2xl font-bold text-[#D4AF37] text-center py-6" data-id="element-42">
              Lo que te falta no está fuera. Está dentro.
            </p>
            <p data-id="element-43">
              Lo que falla no es tu look. Es tu marco interno. Es tu energía, tu
              forma de mostrarte, tu congruencia emocional.
            </p>
          </div>
        </div>
      </Section>

      {/* What's Different */}
      <Section delay={0.3} data-id="element-44">
        <div className="max-w-5xl mx-auto" data-id="element-45">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center text-[#D4AF37]" data-id="element-46">
            ¿Qué tiene este libro que lo hace diferente?
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-6" data-id="element-47">
            {[{
            title: 'Ejercicios de mentalidad',
            icon: '🧠'
          }, {
            title: 'Técnicas de postura y voz',
            icon: '🎯'
          }, {
            title: 'Lenguaje corporal atractivo',
            icon: '💪'
          }, {
            title: 'Hojas de trabajo',
            icon: '📝'
          }, {
            title: 'Calibración emocional',
            icon: '❤️'
          }, {
            title: 'Conversación auténtica',
            icon: '💬'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-[#8B2635]/20 to-[#8B2635]/5 border border-[#8B2635]/40 rounded-xl p-6 text-center" data-id="element-48">
                <div className="text-4xl mb-3" data-id="element-49">{item.icon}</div>
                <h3 className="text-lg font-bold text-[#D4AF37]" data-id="element-50">
                  {item.title}
                </h3>
              </motion.div>)}
          </div>

          <div className="bg-[#8B2635]/10 border-2 border-[#8B2635] rounded-2xl p-8 text-center" data-id="element-51">
            <p className="text-2xl md:text-3xl font-bold text-[#D4AF37]" data-id="element-52">
              No necesitas más validación externa.
            </p>
            <p className="text-xl md:text-2xl mt-3" data-id="element-53">
              Necesitas construir tu seguridad interna.
            </p>
          </div>
        </div>
      </Section>

      {/* Author Story */}
      <Section delay={0.2} data-id="element-54">
        <div className="max-w-4xl mx-auto" data-id="element-55">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center text-[#D4AF37]" data-id="element-56">
            Mi historia podría ser la tuya...
          </h2>
          <div className="space-y-4 text-lg md:text-xl leading-relaxed" data-id="element-57">
            <p data-id="element-58">
              Durante años fui ese tipo: tartamudo, nervioso, tembloroso. Iba a
              fiestas y terminaba en la esquina, con una copa, viendo cómo los
              demás se llevaban la atención.
            </p>
            <p data-id="element-59">
              Cada intento era un fracaso. Cada fracaso, una herida.{' '}
              <span className="text-[#8B2635] font-semibold" data-id="element-60">
                Me sentía roto
              </span>
              .
            </p>
            <p data-id="element-61">
              Probé de todo: gimnasio, ropa, perfumes, autoayuda, frases... Nada
              funcionó.
            </p>
            <div className="bg-[#8B2635]/10 border-l-4 border-[#D4AF37] rounded-r-xl p-6 my-6" data-id="element-62">
              <p className="text-xl md:text-2xl font-bold text-[#D4AF37] mb-3" data-id="element-63">
                Hasta que entendí que el verdadero cambio no era externo. Era
                interno.
              </p>
              <p className="text-lg md:text-xl" data-id="element-64">
                Cambié mi diálogo interno. Mi energía. Mi postura. Mi forma de
                ver el rechazo.
              </p>
            </div>
            <p data-id="element-65">
              Y un día... conecté. Con fluidez. Sin máscaras. Y descubrí algo:{' '}
              <span className="text-[#D4AF37] font-semibold" data-id="element-66">
                el verdadero atractivo nace de la autenticidad
              </span>
              .
            </p>
            <p className="text-center text-xl md:text-2xl font-bold text-[#D4AF37] pt-6" data-id="element-67">
              Por eso escribí este libro. Para entregarte el mapa que a mí me
              tomó años construir.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-8 text-center" data-id="element-68">
            <motion.button onClick={() => {
            const pricingSection = document.getElementById('pricing-section');
            if (pricingSection) {
              pricingSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-[#8B2635] text-[#F5F5DC] px-10 py-5 rounded-lg text-xl font-bold hover:bg-[#A02D3F] transition-colors shadow-2xl cursor-pointer" data-facebook-pixel="no-track" data-id="element-69">
              Quiero Esta Transformación
            </motion.button>
            <p className="mt-3 text-[#F5F5DC]/70 text-sm md:text-base" data-id="element-70">
              Descubre la oferta completa con bonos exclusivos
            </p>
          </motion.div>
        </div>
      </Section>

      {/* Outcomes */}
      <Section delay={0.3} data-id="element-71">
        <div className="max-w-5xl mx-auto" data-id="element-72">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center text-[#D4AF37]" data-id="element-73">
            Esto es lo que puedes lograr
          </h2>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-74">
            {['Ser recordado', 'Tener citas que fluyen con naturalidad', 'Conectar sin miedo, sin esfuerzo', 'Atraer sin depender de tu físico', 'Ser el hombre que entra a un lugar... y se nota'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-4 bg-[#1a1a1a] border border-[#D4AF37]/30 rounded-xl p-5" data-id="element-75">
                <div className="w-3 h-3 bg-[#D4AF37] rounded-full flex-shrink-0" data-id="element-76"></div>
                <p className="text-lg md:text-xl" data-id="element-77">{item}</p>
              </motion.div>)}
          </div>

          <div className="mt-8 bg-gradient-to-r from-[#8B2635]/20 to-[#D4AF37]/10 border-2 border-[#D4AF37] rounded-2xl p-8" data-id="element-78">
            <h3 className="text-3xl md:text-4xl font-bold mb-4 text-center text-[#D4AF37]" data-id="element-79">
              Imagina esta vida:
            </h3>
            <p className="text-xl md:text-2xl text-center leading-relaxed" data-id="element-80">
              Caminas con confianza. Hablas sin dudar. Las personas se sienten
              atraídas por tu energía. Te sientes{' '}
              <span className="text-[#D4AF37] font-semibold" data-id="element-81">
                libre, fuerte, auténtico
              </span>
              .
            </p>
          </div>
        </div>
      </Section>

      {/* What This Book Gives */}
      <Section delay={0.2} data-id="element-82">
        <div className="max-w-4xl mx-auto text-center" data-id="element-83">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-[#D4AF37]" data-id="element-84">
            Este libro te da lo que otros no
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-85">
            {[{
            title: 'Nada de manipulación',
            subtitle: 'Desarrollo real'
          }, {
            title: 'Nada de frases recicladas',
            subtitle: 'Masculinidad íntegra'
          }, {
            title: 'Nada de "sé rudo y ya"',
            subtitle: 'Poder con ética'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-[#1a1a1a] border-2 border-[#8B2635] rounded-xl p-6" data-id="element-86">
                <p className="text-xl font-bold text-[#D4AF37] mb-2" data-id="element-87">
                  {item.title}
                </p>
                <p className="text-lg text-[#F5F5DC]/80" data-id="element-88">{item.subtitle}</p>
              </motion.div>)}
          </div>

          {/* MID-PAGE CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-89">
            <motion.button onClick={() => {
            const pricingSection = document.getElementById('pricing-section');
            if (pricingSection) {
              pricingSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-[#D4AF37] text-[#0a0a0a] px-12 py-6 rounded-xl text-xl md:text-2xl font-bold hover:bg-[#E5C047] transition-colors shadow-2xl cursor-pointer" data-facebook-pixel="no-track" data-id="element-90">
              Ver Oferta Especial 🎁
            </motion.button>
            <p className="mt-3 text-[#F5F5DC]/70 text-sm md:text-base" data-id="element-91">
              Incluye 2 bonos gratis por tiempo limitado
            </p>
          </motion.div>
        </div>
      </Section>

      {/* PRODUCT & PRICING SECTION - Add ID for scroll target */}
      <Section delay={0.3} data-id="element-92">
        <div id="pricing-section" className="max-w-7xl mx-auto" data-id="element-93">
          {/* Urgency Banner */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-[#8B2635] to-[#A02D3F] text-center py-4 px-6 rounded-t-3xl" data-id="element-94">
            <p className="text-xl md:text-2xl font-bold text-[#F5F5DC]" data-id="element-95">
              🎁 OFERTA ESPECIAL: Bono Gratis Solo Por Hoy
            </p>
          </motion.div>

          <div className="bg-gradient-to-br from-[#8B2635]/20 via-[#1a1a1a] to-[#0a0a0a] border-2 border-[#D4AF37] border-t-0 rounded-b-3xl overflow-hidden" data-id="element-96">
            <div className="p-8 md:p-16" data-id="element-97">
              {/* Main Product Card */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="bg-gradient-to-br from-[#8B2635] to-[#6B1D28] rounded-3xl overflow-hidden mb-8 shadow-2xl" data-id="element-98">
                <div className="grid md:grid-cols-2 gap-8 items-center p-8 md:p-12" data-id="element-99">
                  {/* Product Image */}
                  <div className="flex justify-center" data-id="element-100">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inDwm72HZDrwHpwF2Se7pf/img_oferta_1.png" alt="El Arte de Influir en las Personas" className="w-full max-w-md rounded-xl shadow-2xl" data-id="element-101" />
                  </div>

                  {/* Product Details */}
                  <div className="text-left" data-id="element-102">
                    <h3 className="text-3xl md:text-4xl font-bold text-[#F5F5DC] mb-4" data-id="element-103">
                      El Arte de Influir en las Personas
                    </h3>
                    <p className="text-lg text-[#F5F5DC]/80 mb-6" data-id="element-104">
                      Tu guía práctica para la transformación personal
                    </p>

                    {/* Price */}
                    <div className="mb-6" data-id="element-105">
                      <div className="flex items-baseline gap-3 mb-2" data-id="element-106">
                        <span className="text-5xl md:text-6xl font-bold text-[#D4AF37]" data-id="element-107">
                          $7.97
                        </span>
                        <span className="text-2xl text-[#F5F5DC]/70" data-id="element-108">USD</span>
                      </div>
                      <div className="flex items-center gap-2 text-[#D4AF37]" data-id="element-109">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" data-id="element-110">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-111" />
                        </svg>
                        <span className="font-semibold" data-id="element-112">
                          Precio especial de lanzamiento
                        </span>
                      </div>
                    </div>

                    {/* Features */}
                    <ul className="space-y-3 mb-8" data-id="element-113">
                      {['Descarga inmediata en PDF', 'Ejercicios prácticos listos para imprimir', 'Método paso a paso adaptado a LATAM', 'Acceso de por vida'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-114">
                          <div className="w-6 h-6 rounded-full bg-[#D4AF37]/20 border-2 border-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-115">
                            <svg className="w-4 h-4 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-116">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-117" />
                            </svg>
                          </div>
                          <span className="text-[#F5F5DC] text-base md:text-lg" data-id="element-118">
                            {item}
                          </span>
                        </li>)}
                    </ul>

                    {/* CTA Button */}
                    <motion.a href="https://www.arisalabs.com/cart/49555037716757:1" target="_blank" rel="noopener noreferrer" onClick={trackLeadEvent} whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} className="w-full bg-[#D4AF37] text-[#0a0a0a] px-8 py-4 rounded-xl text-lg md:text-xl font-bold hover:bg-[#E5C047] transition-colors shadow-xl mb-4 block text-center cursor-pointer" data-id="element-119">
                      📥 Obtener mi guía ahora
                    </motion.a>

                    <div className="flex items-center justify-center gap-2 text-[#F5F5DC]/70 text-sm" data-id="element-120">
                      <svg className="w-4 h-4 text-[#D4AF37]" fill="currentColor" viewBox="0 0 20 20" data-id="element-121">
                        <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-122" />
                      </svg>
                      <span data-id="element-123">🔥 Pago seguro • Descarga instantánea</span>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Bonus Banner */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="bg-gradient-to-r from-[#D4AF37] to-[#E5C047] rounded-2xl py-6 px-8 mb-8 text-center shadow-xl" data-id="element-124">
                <h3 className="text-2xl md:text-3xl font-bold text-[#0a0a0a] flex items-center justify-center gap-3" data-id="element-125">
                  <span data-id="element-126">🎁</span>
                  BONOS GRATIS INCLUIDOS
                  <span data-id="element-127">🎁</span>
                </h3>
              </motion.div>

              {/* Bonus Card #1 */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="bg-gradient-to-br from-[#FFF9E6] to-[#F5F5DC] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#D4AF37] mb-8" data-id="element-128">
                <div className="grid md:grid-cols-2 gap-8 items-center p-8 md:p-12" data-id="element-129">
                  {/* Bonus Image */}
                  <div className="flex justify-center" data-id="element-130">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ppb4zaZBFg6gQJEo5MyDY4/imagen_oferta.png" alt="Orgasmos Salvajes - 20 Técnicas Avanzadas" className="w-full max-w-md rounded-xl shadow-2xl" data-id="element-131" />
                  </div>

                  {/* Bonus Details */}
                  <div className="text-left" data-id="element-132">
                    <div className="flex items-center gap-3 mb-4" data-id="element-133">
                      <span className="text-4xl" data-id="element-134">🎁</span>
                      <h4 className="text-2xl md:text-3xl font-bold text-[#8B2635]" data-id="element-135">
                        BONO #1
                      </h4>
                    </div>

                    <h5 className="text-xl md:text-2xl font-bold text-[#0a0a0a] mb-4" data-id="element-136">
                      "Orgasmos Salvajes: 20 Técnicas Avanzadas"
                    </h5>

                    <p className="text-base md:text-lg text-[#0a0a0a]/80 mb-6 leading-relaxed" data-id="element-137">
                      Llévala a orgasmos intensos, múltiples y memorables.
                      Domina su cuerpo y mente con técnicas que la harán adicta
                      a tu conexión.
                    </p>

                    {/* Bonus Features */}
                    <ul className="space-y-3 mb-8" data-id="element-138">
                      {['Sexting psicológico y monólogo dominante', 'Dominio de zonas erógenas olvidadas', 'Juegos de poder con respeto y presencia', 'Fidelización emocional post-orgasmo', 'Ser recordado como su mejor amante'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-139">
                          <div className="w-6 h-6 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-140">
                            <svg className="w-4 h-4 text-[#0a0a0a]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-141">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-142" />
                            </svg>
                          </div>
                          <span className="text-[#0a0a0a] text-sm md:text-base" data-id="element-143">
                            {item}
                          </span>
                        </li>)}
                    </ul>

                    {/* Free Badge */}
                    <div className="bg-white border-2 border-[#D4AF37] rounded-xl py-4 px-6 text-center" data-id="element-144">
                      <p className="text-xl md:text-2xl font-bold text-[#8B2635]" data-id="element-145">
                        Hoy gratis
                      </p>
                      <p className="text-sm text-[#0a0a0a]/60 mt-1" data-id="element-146">
                        Valor: $15.55 • Solo por tiempo limitado
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Bonus Card #2 */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} className="bg-gradient-to-br from-[#FFF9E6] to-[#F5F5DC] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#D4AF37] mb-8" data-id="element-147">
                <div className="grid md:grid-cols-2 gap-8 items-center p-8 md:p-12" data-id="element-148">
                  {/* Bonus Image */}
                  <div className="flex justify-center" data-id="element-149">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hBwVte16ffGqw2VLZEMP7k/imagen_oferta_3.png" alt="Voz que Atrae - El Arte de Hablar y Atraer" className="w-full max-w-md rounded-xl shadow-2xl" data-id="element-150" />
                  </div>

                  {/* Bonus Details */}
                  <div className="text-left" data-id="element-151">
                    <div className="flex items-center gap-3 mb-4" data-id="element-152">
                      <span className="text-4xl" data-id="element-153">🎁</span>
                      <h4 className="text-2xl md:text-3xl font-bold text-[#8B2635]" data-id="element-154">
                        BONO #2
                      </h4>
                    </div>

                    <h5 className="text-xl md:text-2xl font-bold text-[#0a0a0a] mb-4" data-id="element-155">
                      "Voz que Atrae"
                    </h5>

                    <p className="text-base md:text-lg text-[#0a0a0a]/80 mb-6 leading-relaxed" data-id="element-156">
                      Domina el tono, ritmo y pausa que despiertan deseo.
                      Aprende a hablar con presencia, autoridad y magnetismo —
                      ya sea en persona o por mensaje de voz.
                    </p>

                    {/* Bonus Features */}
                    <ul className="space-y-3 mb-8" data-id="element-157">
                      {['Control de tono y ritmo vocal para generar atracción', 'Uso estratégico de pausas y silencios', 'Proyección de autoridad y confianza', 'Técnicas para mensajes de voz magnéticos', 'Presencia vocal que no se olvida'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-158">
                          <div className="w-6 h-6 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-159">
                            <svg className="w-4 h-4 text-[#0a0a0a]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-160">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-161" />
                            </svg>
                          </div>
                          <span className="text-[#0a0a0a] text-sm md:text-base" data-id="element-162">
                            {item}
                          </span>
                        </li>)}
                    </ul>

                    {/* Free Badge */}
                    <div className="bg-white border-2 border-[#D4AF37] rounded-xl py-4 px-6 text-center" data-id="element-163">
                      <p className="text-xl md:text-2xl font-bold text-[#8B2635]" data-id="element-164">
                        Hoy gratis
                      </p>
                      <p className="text-sm text-[#0a0a0a]/60 mt-1" data-id="element-165">
                        Valor: $15.55 • Solo disponible durante esta campaña
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Value Summary */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="bg-[#0a0a0a] border-2 border-[#D4AF37] rounded-2xl p-8 my-8" data-id="element-166">
                <div className="max-w-2xl mx-auto" data-id="element-167">
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-[#D4AF37]/30" data-id="element-168">
                    <span className="text-lg md:text-xl text-[#F5F5DC]" data-id="element-169">
                      El Arte de Influir en las Personas
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-[#D4AF37]" data-id="element-170">
                      $7.97
                    </span>
                  </div>
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-[#D4AF37]/30" data-id="element-171">
                    <span className="text-lg md:text-xl text-[#F5F5DC]" data-id="element-172">
                      Bono #1: Orgasmos Salvajes
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-[#8B2635] line-through" data-id="element-173">
                      $15.55
                    </span>
                  </div>
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-[#D4AF37]/30" data-id="element-174">
                    <span className="text-lg md:text-xl text-[#F5F5DC]" data-id="element-175">
                      Bono #2: Voz que Atrae
                    </span>
                    <span className="text-xl md:text-2xl font-bold text-[#8B2635] line-through" data-id="element-176">
                      $15.55
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-177">
                    <span className="text-2xl md:text-3xl font-bold text-[#D4AF37]" data-id="element-178">
                      Total Hoy:
                    </span>
                    <div className="text-right" data-id="element-179">
                      <div className="text-lg text-[#F5F5DC]/60 line-through" data-id="element-180">
                        $39.07
                      </div>
                      <div className="text-4xl md:text-5xl font-bold text-[#D4AF37]" data-id="element-181">
                        $7.97
                      </div>
                    </div>
                  </div>
                  <p className="text-center mt-4 text-[#F5F5DC]/70 font-semibold" data-id="element-182">
                    Ahorras $31.10 • Oferta válida solo por hoy
                  </p>
                </div>
              </motion.div>

              {/* Final CTA */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="text-center" data-id="element-183">
                <motion.a href="https://www.arisalabs.com/cart/49555037716757:1" target="_blank" rel="noopener noreferrer" onClick={trackLeadEvent} whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.97
              }} className="inline-block bg-[#D4AF37] text-[#0a0a0a] px-12 py-6 rounded-xl text-xl md:text-2xl font-bold hover:bg-[#E5C047] transition-colors shadow-2xl mb-6 cursor-pointer" data-id="element-184">
                  Obtener Todos los eBooks Ahora
                </motion.a>

                <div className="flex items-center justify-center gap-3 text-[#F5F5DC]/70" data-id="element-185">
                  <svg className="w-6 h-6 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-186">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-187" />
                  </svg>
                  <p className="text-sm md:text-base" data-id="element-188">
                    Descarga segura • Pago protegido • Acceso inmediato
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </Section>

      {/* Metaphors */}
      <Section delay={0.3} data-id="element-189">
        <div className="max-w-5xl mx-auto" data-id="element-190">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center text-[#D4AF37]" data-id="element-191">
            3 Metáforas que resumen tu transformación
          </h2>

          <div className="space-y-6" data-id="element-192">
            {[{
            from: 'De arbusto a imán',
            desc: 'antes invisible, ahora poderoso',
            emoji: '🧲'
          }, {
            from: 'De cámara oscura a proyector',
            desc: 'antes escondido, ahora brillante',
            emoji: '💡'
          }, {
            from: 'De eco a altavoz',
            desc: 'antes dudando, ahora resonando',
            emoji: '📢'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-gradient-to-r from-[#8B2635]/20 to-transparent border-l-4 border-[#D4AF37] rounded-r-xl p-6 flex items-center gap-5" data-id="element-193">
                <div className="text-5xl" data-id="element-194">{item.emoji}</div>
                <div data-id="element-195">
                  <h3 className="text-2xl md:text-3xl font-bold text-[#D4AF37] mb-1" data-id="element-196">
                    {item.from}
                  </h3>
                  <p className="text-lg md:text-xl text-[#F5F5DC]/80" data-id="element-197">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </Section>

      {/* Final CTA */}
      <Section delay={0.2} data-id="element-198">
        <div className="max-w-4xl mx-auto text-center" data-id="element-199">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 text-[#D4AF37]" data-id="element-200">
            ¿Listo para duplicar tu poder de atracción?
          </h2>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed" data-id="element-201">
            Descarga ahora "El Arte de Influir en las Personas" y empieza tu
            transformación hoy mismo.
          </p>

          <div className="bg-[#8B2635]/10 border-2 border-[#8B2635] rounded-2xl p-8 mb-8" data-id="element-202">
            <div className="space-y-3 text-xl md:text-2xl font-bold text-[#F5F5DC]" data-id="element-203">
              <p data-id="element-204">No más rechazo silencioso.</p>
              <p data-id="element-205">No más ansiedad que paraliza.</p>
              <p data-id="element-206">No más sentirse invisible.</p>
            </div>
          </div>

          <motion.button onClick={() => {
          const pricingSection = document.getElementById('pricing-section');
          if (pricingSection) {
            pricingSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-[#D4AF37] text-[#0a0a0a] px-12 py-6 rounded-xl text-2xl font-bold hover:bg-[#E5C047] transition-colors shadow-2xl cursor-pointer" data-facebook-pixel="no-track" data-id="element-207">
            Ver Oferta Completa
          </motion.button>

          <p className="mt-6 text-lg md:text-xl text-[#F5F5DC]/70" data-id="element-208">
            Haz clic para ver todos los bonos incluidos y comenzar tu
            transformación
          </p>
        </div>
      </Section>

      {/* Footer */}
      <footer className="border-t border-[#8B2635]/30 py-6 mt-8" data-id="element-209">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-210">
          <p className="text-[#F5F5DC]/60" data-id="element-211">
            © 2024 El Arte de Influir en las Personas. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}
// Reusable Section Component with Animation
function Section({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <motion.section ref={ref} initial={{
    opacity: 0,
    y: 50
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.6,
    delay
  }} className="px-6 py-4" data-id="element-212">
      {children}
    </motion.section>;
}